import { render, staticRenderFns } from "./ProjectFormWrapper.vue?vue&type=template&id=8261da28&scoped=true&"
import script from "./ProjectFormWrapper.vue?vue&type=script&lang=js&"
export * from "./ProjectFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8261da28",
  null
  
)

export default component.exports